import moment from 'moment';

import { DeviceType } from '../../../__generated__/graphql';
import type { DeviceTrip, DeviceTripAPI } from '../Definitions';

export const fixedDeviceTripAPIMock: DeviceTripAPI = {
  device_id: '4532440256',
  device: {
    device_id: '4532440256',
    icc_id: '5170000200755545',
    imei: '359316076583696',
    fleet_id: '12768cf5-e959-4f2a-a804-e0f8bbdcaeeb',
    associated_at: '2019-02-15T18:35:31.840Z',
    cobli_id: '14SP',
    chip_number: '+44762497160542',
    chip_operator: 'Eseye',
    type: 'LMU3030',
    status: 'commodate',
  },
  vehicle: {
    device_id: '4532440256',
    vehicle_id: 'ba61cd9c-08de-4d07-860a-4b8bf112ba12',
    associated_at: '2019-02-15T18:35:31.840Z',
    id: 'ba61cd9c-08de-4d07-860a-4b8bf112ba12',
    updated_at: '2019-04-11T14:37:04.375Z',
    fleet_id: '12768cf5-e959-4f2a-a804-e0f8bbdcaeeb',
    license_plate: 'ABC-1234 - _CB14SP',
    size: null,
    fuel_type: null,
    brand: 'Fiat',
    model: 'Palio',
    year: null,
    fuel_price: 4.494,
    fuel_consumption: 8,
    using_default_price: true,
    using_default_consumption: true,
    is_suggestion: false,
  },
  drivers: [
    {
      id: 'a43610ca-5efe-4792-8839-2cf95ac819ce',
      fleet_id: '12768cf5-e959-4f2a-a804-e0f8bbdcaeeb',
      name: 'Senhor motorista',
      phone_numbers: ['11965124514'],
      active: true,
      first_license_acquirement_date: '2040-01-20T04:00:00.000Z',
      license_expiration_date: '2040-01-20T04:00:00.000Z',
      license_category: 'B',
      period_driven: [
        {
          start_timestamp: 1552659672576,
          end_timestamp: 1555448618595,
        },
      ],
    },
  ],
  path_geojson: {
    type: 'Feature',
    geometry: {
      type: 'LineString',
      coordinates: [
        [-47.467620849609375, -23.530906677246094],
        [-47.46761703491211, -23.53090476989746],
        [-47.4676399230957, -23.53089714050293],
        [-47.4676513671875, -23.530885696411133],
      ],
    },
    properties: {
      device_id: '4532440256',
      timestamps: ['2019-04-16T20:51:46.000Z', '2019-04-16T20:51:51.000Z', '2019-04-16T20:51:56.000Z', '2019-04-16T20:52:01.000Z'],
      speeds_in_km: [4.9679999351501465, 0, null, 0],
      total_distances_in_m: [10331028, 10331030, null, 10331030],
      headings: [289, 282, null, 282],
    },
  },
};

export const fixedDeviceTripMock: DeviceTrip = {
  deviceId: '4532440256',
  deviceType: DeviceType.Obd,
  vehicle: {
    vehicleId: 'ba61cd9c-08de-4d07-860a-4b8bf112ba12',
    licensePlate: 'ABC-1234 - _CB14SP',
    fuelConsumption: 8,
    fuelPrice: 4.494,
    fuelType: null,
    brand: 'Fiat',
    model: 'Palio',
  },
  drivers: [
    {
      name: 'Senhor motorista',
      id: 'a43610ca-5efe-4792-8839-2cf95ac819ce',
    },
  ],
  pathGeojson: {
    type: 'Feature',
    geometry: {
      type: 'LineString',
      coordinates: [
        [-47.467620849609375, -23.530906677246094],
        [-47.46761703491211, -23.53090476989746],
        [-47.4676399230957, -23.53089714050293],
        [-47.4676513671875, -23.530885696411133],
      ],
    },
    properties: [
      {
        timestamp: moment('2019-04-16T20:51:46.000Z').valueOf(),
        speedInKm: 4.9679999351501465,
        accumulatedDistance: 10331028,
        heading: 289,
      },
      {
        timestamp: moment('2019-04-16T20:51:51.000Z').valueOf(),
        speedInKm: 0,
        accumulatedDistance: 10331030,
        heading: 282,
      },
      {
        timestamp: moment('2019-04-16T20:51:56.000Z').valueOf(),
        speedInKm: null,
        accumulatedDistance: null,
        heading: null,
      },
      {
        timestamp: moment('2019-04-16T20:52:01.000Z').valueOf(),
        speedInKm: 0,
        accumulatedDistance: 10331030,
        heading: 282,
      },
    ],
  },
};
